import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UtilityService } from "../shared/services/Utility.service";
import * as $ from 'jquery';
import { UserSettings } from './usersettings';
import { Hotkey, HotkeysService } from 'angular2-hotkeys';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CustomDateFormat } from '../main/CustomDateFormat';
import { DatePipe } from '@angular/common';
import { CommonFunction } from '../../app/main/CommonFunction';
import { ViewChild, ElementRef } from '@angular/core';
import { GridApi, ColumnApi } from 'ag-grid-community';



import { NgbDateStruct, NgbCalendar, NgbDateParserFormatter, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
var moment = require('moment');


@Component({
    selector: 'vend-template-Global',
    template: require('./vendorTemplateGlobal.html'),
    styles: [``]
})
export class vendorTemplateGlobalComponent implements OnInit {
    @Input("cValue") cValue :any;
    @Input( "dValue")  dvalue :any;
    @Input('vendorList1') vendorList1: any;
    @ViewChild('ledger') ledger: ElementRef;
    @ViewChild('expiryLedger') expiryLedger: ElementRef;
    @ViewChild('orderhistory') orderhistory: ElementRef;

    @Output() SelectedVendor = new EventEmitter();
    static parameters = [UtilityService, HotkeysService,NgbModal, NgbModalConfig,HttpClient,CustomDateFormat,DatePipe,CommonFunction]
    constructor(public utilityService: UtilityService, private hotkeysService: HotkeysService, private modalService: NgbModal, config: NgbModalConfig,private http: HttpClient,public customDateFormat: CustomDateFormat,public datePipe: DatePipe ,public commonFunction : CommonFunction) {
        this.hotkeysService = hotkeysService;
    }
    gridApiVen: any;
    paginationConf:any;
    gridColumnApiCust: any;
    vendorList: any;
    vendorDef: any;
    rowSelectionSingle: string;
    searchValue: any;
    d :any;
    defaultColDefVen:any;
    selectedVendorInfo: any;
    public hotkeyList: Hotkey[];
    public hotkeyListModal: Hotkey[];
    public unitInfo: any;
    busy: Subscription;
    dateFormat: any;
    vendorLedgercolumnDefs: any;
    vendorLedgerRowData: any;
    vendorLedgerRowDataFooter: any;
    ledgerDetails: any;
    ledgerDebit: any;
    ledgerCredit: any;
    ledgerClosingBalance: any;
    ledgerOpeningBalance: any;
    ledgerRowSelected: any = [];
    orderSearch :any;
    orderhistorycolumnDefs :any;
    orderhistoryrowData :any;
    gridApiOrderHis: any;
    gridColumnApiOrderHis: any;
    expiryLedgerRef: NgbModalRef;
    gridApiexpiryLedger :any;
    public gridColumnApiexpiryLedger: any;
    public orderSearch1: any;
    public expiryLedgerrowDataFooter: any;
    public expiryLedgeBalance: any;
    public expiryLedgeledgerDebit: any;
    public expiryLedgeledgerCredit: any;
    venOutstandingGrid: GridApi;
    expiryLedgercolumnDefs:any;
    expiryLedgerrowData:any;
    public ledgerSearch: any;
    gridApiVendorLedger: any;
    gridColumnApiVendorLedger: any;
    ledgerRef: NgbModalRef;
    invoiceInfo: any;
    Vendor_Name: any;
    Vendor_LegalName: any;
    Vendor_Address1 : any;
    Vendor_Full_Address : any
    Vendor_Phone : any;
    Vendor_Mobile : any;
    Vendor_EmailID:  any;
    CreditLimit:  any;
    CreditDays:  any;
    PayTerm_Desc:  any;
    Vendor_GSTNo:  any;
    Vendor_TCS:  any;

    filterType:any;
    ngOnInit(): void {
      //   console.log('product template init!');
        this.rowSelectionSingle = "single";
        this.d = this.dvalue;
        this.paginationConf = true;
        this.initHotkeys();
        this.filterType = 'Vendor_Name';
        this.orderSearch = {};
        this.orderSearch1 = {};
        this.orderSearch.filtertype = 'C';
        this.ledgerSearch = {};
        this.ledgerSearch.filtertype = 'C';

        this.ledgerSearch.From_Date = this.oneMonthAgo();
        this.ledgerSearch.To_Date = new Date();

        this.unitInfo = JSON.parse(localStorage.getItem('permission'))[0];
        this.dateFormat = JSON.parse(localStorage.getItem('permission'))[0];
        this.orderSearch.From_Date = this.oneMonthAgo();
        this.orderSearch.To_Date = new Date();
        this.orderSearch1.From_Date = this.oneMonthAgo();
        this.orderSearch1.To_Date = new Date();

    }


    oneMonthAgo() {
        var monthAgo = new Date(
            new Date().getFullYear(),
            new Date().getMonth() - 1,
            new Date().getDate()
        );
        return monthAgo;
    }

    ngAfterViewInit() {
        this.paginationConf =true;
    }
    onGridReadyVen(params){

        var parent = this;
        $( "#filter-text-box").keypress(function(event) {
            if (event.keyCode == 13) {
                parent.venSelectionMain(parent);
            }
        });

        this.vendorDef = [
            { headerName: 'Code', field: 'Vendor_Code', width: 97 },
            { headerName: 'Vendor Name', field: 'Vendor_Name', width: 168 },            
            { headerName: 'Address', field: 'Vendor_Address1', width: 194 },
            { headerName: 'City', field: 'City_Desc', width: 120 },
            { headerName: 'State', field: 'State_Desc', width: 150 },
            { headerName: 'Mobile No', field: 'Vendor_Mobile', width: 109 },
            { headerName: 'Email ID', field: 'Vendor_EmailID', width: 236 },
            { headerName: 'Alt Code', field: 'altCode', width: 65},
        ];
       
        this.vendorList = this.vendorList1;
      //   console.log("vendor List"+this.vendorList);
       
        this.gridApiVen = params.api;
        this.gridColumnApiCust = params.columnApi;
     
        setTimeout( () => {
            //this.gridApiVen.sizeColumnsToFit();
            this.selectedVendorInfo= this.gridApiVen.getModel().getRow(0).setSelected(true);
          //   console.log(this.selectedVendorInfo);
          }, 100);
      //   this.gridColumnApiCust.autoSizeColumns(allColumnIds);
       
         this.defaultColDefVen = {
             resizable: true,
             sortable : true,

         };
       
        var myInputCust = document.getElementById("vendormaster");
        let self = this;
        $("#vendormaster").keypress(function (event) {
          //   console.log("Handler for .keypress() called:", event);
        });
       
    }

    initHotkeys() {
        this.hotkeyList = [];
        this.hotkeyListModal = [];
        
        const altd = new Hotkey('alt+d', (event: KeyboardEvent): boolean => {
            $('.master-header label[name="Vendor_Code"]').trigger('click');
            this.OnVendorButtonChange();
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altd);
        this.hotkeysService.add(altd);

        const altn = new Hotkey('alt+n', (event: KeyboardEvent): boolean => {
            $('.master-header label[name="Vendor_Name"]').trigger('click');
            this.OnVendorButtonChange();
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altn);
        this.hotkeysService.add(altn);

        const altc = new Hotkey('home', (event: KeyboardEvent): boolean => {
            this.clearAllFilter();
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altc);
        this.hotkeysService.add(altc);

        const altl = new Hotkey('alt+l', (event: KeyboardEvent): boolean => {
            this.ledgerModal(this.ledger);
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altl);
        this.hotkeysService.add(altl);
        
        const alte = new Hotkey('alt+e', (event: KeyboardEvent): boolean => {
            this.expiryLedgerModal(this.expiryLedger);
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(alte);
        this.hotkeysService.add(alte);

        const altp = new Hotkey('alt+p', (event: KeyboardEvent): boolean => {
            this.orderhistoryModal(this.orderhistory);
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altp);
        this.hotkeysService.add(altp);
    }

    ngOnDestroy() {
        this.hotkeysService.remove(this.hotkeyList);
    }

    OnVendorButtonChange(){
        this.searchValue = "";
        $('.master-header #filter-text-box').focus();
        this.quickSearch('','vendor');
    }
    
    gridEventDown(event) {
        if (event.keyCode == 13) {
          //   console.log("keydown", event);
            this.venSelectionMain(this);
        } else if (event.keyCode == 8) {
            setTimeout(() => {
                $('#filter-text-box').focus().select();
            }, 200);
        } else if (event.keyCode >= 65 && event.keyCode <= 90) {
            $('#filter-text-box').focus().select();
        }
    }
    private venSelectionMain(self: this) {
        let selectedRows = self.gridApiVen.getSelectedRows();
        let vend = selectedRows[0];
      //   console.log("selected cust:", selectedRows[0]);

        if (vend != undefined) {
          //   console.log('selected ccustomer:', vend);
            this.SelectedVendor.emit(vend);
        }
    }
   
  
    venSelected(event) {
        let selectedRowVen = this.gridApiVen.getSelectedRows();
        this.selectedVendorInfo = selectedRowVen[0];
        this.selectedVendorInfo.LastInvoiceDays = 0;
        this.SetProductDetails(this.selectedVendorInfo);
      //   console.log(this.selectedVendorInfo);
        //this.todayD = moment(this.poapproval.Doc_Date).format(this.dateFormat.dateInputFormat);
        if (this.selectedVendorInfo.Invoice_Details){
            this.invoiceInfo = JSON.parse(this.selectedVendorInfo.Invoice_Details);
            if(this.invoiceInfo.length > 0 && this.invoiceInfo[0].Invoice_Date != null && this.invoiceInfo[0].Invoice_Date != ""){
                let invoice = this.invoiceInfo.sort((val1, val2) => {return <any>(new Date(val2.Invoice_Date)) - <any>(new Date(val1.Invoice_Date))});
                var diff = Math.abs(new Date().getTime() - new Date(invoice[0].Invoice_Date).getTime());
                this.selectedVendorInfo.LastInvoiceDays = Math.floor(diff / (1000 * 3600 * 24));
            }
        }
    }
    SetProductDetails(selectedVendorInfo) { 
        this.Vendor_Name = selectedVendorInfo.Vendor_Name;
        this.Vendor_LegalName = selectedVendorInfo.Vendor_LegalName;
        this.Vendor_Address1 = selectedVendorInfo.Vendor_Address1;
        this.Vendor_Mobile = selectedVendorInfo.Vendor_Mobile;
        this.Vendor_EmailID = selectedVendorInfo.Vendor_EmailID;
        this.CreditLimit = selectedVendorInfo.CreditLimit;
        this.CreditDays = selectedVendorInfo.CreditDays;
        this.PayTerm_Desc = selectedVendorInfo.PayTerm_Desc;
        this.Vendor_Full_Address = selectedVendorInfo.Vendor_Full_Address;
        this.Vendor_Phone = selectedVendorInfo.Vendor_Phone;
        this.Vendor_GSTNo = selectedVendorInfo.Vendor_GSTNo;
        this.Vendor_TCS = (selectedVendorInfo.TCS_Applicable == 0 ? 'No' : 'Yes');

       
    }
    onVendSelectionChanged(event){

        let selectedRows = this.gridApiVen.getSelectedRows();
        let vend = selectedRows[0];
      //   console.log("selected vend:", selectedRows[0]);

        if (vend != undefined) {
          //   console.log('selected Vendor:', vend);
            this.SelectedVendor.emit(vend);
        }
    }
    
    quickSearch(event, id) {
        //console.log(id);        
         if (id == 'vendor') {
            // this.gridApiVen.setQuickFilter(this.searchValue);
            // this.gridApiVen.onFilterChanged();
            // this.gridApiVen.getModel().getRow(0).setSelected(true);
            // //console.log("event.which",event.which);
            // if (event.which == 13 || event.which == 40) {
            //     this.gridApiVen.setFocusedCell(0, "Vendor_Code");
            // }
            this.gridApiVen.setFilterModel(null);
            var sportsFilterComponent = this.gridApiVen.getFilterInstance(this.filterType);
            if(this.searchValue){
                let search = this.searchValue.split(' ');
                sportsFilterComponent.setModel({
                    condition2: {
                        type: "contains",
                        filter: search[1]
                    },
                    condition1: {
                        type: "startsWith",
                        filter: search[0]
                    },
                    operator: "AND"
                });
            }
            this.gridApiVen.onFilterChanged();
            if (Number(this.gridApiVen.getModel().getRowCount()) > 0) {
                this.gridApiVen.getModel().getRow(0).setSelected(true);
                if (event.which == 13 || event.which == 40) {
                    this.gridApiVen.setFocusedCell(0, "Vendor_Code");
                }
            }    
        }
    }

    clearAllFilter() {
        this.searchValue = '';
    }

      /*  <--  Vendor Ledger   */
      
      ledgerModal(ledger) {
  
/*           if (!this.modalService.hasOpenModals()) {
 */             
          this.VendorLedger();
          this.ledgerRef = this.modalService.open(ledger, { size: 'lg', windowClass: 'data-show ledger-modal-popup' });
          setTimeout(() => {
              $('.ledger-modal-popup input#From_Date').focus().select();
              this.initModalQuery('.ledger-modal-popup');
              let ctrlo = new Hotkey('alt+o', (event: KeyboardEvent): boolean => {
                  $('ledger-modal-popup #okbtn').trigger('click');
                  return false; // Prevent bubbling
              }, ['INPUT', 'SELECT', 'TEXTAREA']);
              // this.hotkeyList.push(ctrls);
              this.hotkeyListModal.push(ctrlo);
              this.hotkeysService.add(ctrlo);
              let ctrle = new Hotkey('alt+e', (event: KeyboardEvent): boolean => {
                  $('#excelbtn').trigger('click');
                  return false; // Prevent bubbling
              }, ['INPUT', 'SELECT', 'TEXTAREA']);
              // this.hotkeyList.push(ctrls);
              this.hotkeyListModal.push(ctrle);
              this.hotkeysService.add(ctrle);
  
              let self = this;
              this.ledgerRef.result.then(() => {
                //   console.log("when user closes");
                  self.ledgerRef = undefined;
                  self.removeHotKeyServices(self.hotkeyListModal);
              }, () => {
                //   console.log("backdrop click");
                  self.ledgerRef = undefined;
                  self.removeHotKeyServices(self.hotkeyListModal);
              });
          }, 200);  
     /*  } */      
      }
  
      VendorLedgerGridReady(params) {
          this.gridApiVendorLedger = params.api;
          this.gridColumnApiVendorLedger = params.columnApi;
          this.gridApiVendorLedger.sizeColumnsToFit();
      }
  

      toast = Swal.mixin({
        toast: true,
        position: 'center',
        showConfirmButton: false,
        timer: 3000,
        backdrop: `rgba(30, 30, 37, 0.4)`
    });
      

    toastWarningMsg(msg) {
        this.toast({
            type: 'warning',
            title: msg,
            timer: 3000
        });
    }
      VendorLedger() {
          if (this.ledgerSearch.To_Date < this.ledgerSearch.From_Date) {
              this.toastWarningMsg("To Date cannot be less than From Date");
          }
          else {
              if (this.ledgerSearch.To_Date != null || this.ledgerSearch.From_Date != null) {
                  let To_Date = moment(this.ledgerSearch.To_Date).format('YYYY-MM-DD');
                  let From_Date = moment(this.ledgerSearch.From_Date).format('YYYY-MM-DD');
                  var data = {
                      "Vendor_ID": this.selectedVendorInfo.Vendor_ID, 
                      "Unit_ID": this.unitInfo.Unit_ID, 
                      "Company_ID": this.unitInfo.Company_ID,
                      "From_Date": From_Date, 
                      "To_Date": To_Date
                  };
                  this.busy = this.http.post('/api/vendors/Get_Ledger_Vendor_Wise', data)
                      .subscribe(response => {
                          var res = [];
                          res.push(response);
                          let self = this;
                          this.vendorLedgercolumnDefs = [
                             
                              { headerName: 'Doc Type', field: 'DocType_Desc', width: 200 },
                              { headerName: 'Doc No', field: 'TransNo', width: 170 },
                              { headerName: 'Date', field: 'Doc_Date', width: 105,
                                  cellRenderer: (data) => {
                                      if (data.value) {
                                          return moment(data.value).format(self.dateFormat.dateInputFormat);
                                      }
                                      else {
                                          return '-';
                                      }
                                  }
                              },
                              { headerName: 'Bill No', field: 'Bill_No', width: 150 },
                              { headerName: 'Bill Date', field: 'Bill_Date', width: 105 },
                              { headerName: 'Status', field: 'Status', width: 70 },
                              { headerName: 'Remarks', field: 'Remarks', width: 180 },
                              { headerName: 'Debit', field: 'Debit', width: 100,cellStyle :{ textAlign : 'right'}  },
                              { headerName: 'Credit', field: 'Credit', width: 100,cellStyle :{ textAlign : 'right'}  },
                             
                              //{ headerName: 'Balance', field: 'Balance', width: 150 ,cellStyle :{ textAlign : 'right'} },
                          //{ headerName: '', field: 'DRCR', width: 50  },
                          ];
      
                          this.vendorLedgerRowData = res[0].ledgerData;
                          this.vendorLedgerRowDataFooter = res[0].ledgerFooterData;
                          this.ledgerDetails = this.vendorLedgerRowDataFooter[0];
                          this.ledgerDebit = this.ledgerDetails.Debit;
                          this.ledgerCredit = this.ledgerDetails.Credit;
                          this.ledgerClosingBalance = this.ledgerDetails.Closing_Balance;
                          this.ledgerOpeningBalance = this.ledgerDetails.Opening_Balance;
                          // console.log("ledgerDetails", this.ledgerDetails);
      
                          if (this.vendorLedgerRowData.length > 0) {
                              setTimeout(() => {
                                  let allColumnIds = [];
                                  this.gridApiVendorLedger.getModel().getRow(0).setSelected(true);
                                 // this.gridApiVendorLedger.setFocusedCell(0, "Party_Code");
                                  this.gridColumnApiVendorLedger.getAllColumns().forEach(function (column) {
                                      allColumnIds.push(column.colId);
                                  });
                                  // this.gridColumnApiVendorLedger.autoSizeColumns(allColumnIds);
                                  // this.gridApiVendorLedger.sizeColumnsToFit();
                              }, 100);
                          }
                      })
              } else {
                  this.toastWarningMsg("Please Enter Date");
                  $("#From_Date").focus();
              }
          }      
  
      }
  
      exportExcelVendorLedger() {
          let To_Date = moment(this.ledgerSearch.To_Date).format('DD-MMM-YYYY');
          let From_Date = moment(this.ledgerSearch.From_Date).format('DD-MMM-YYYY');
          let row = this.unitInfo.Company_Name +  '\n' + this.unitInfo.Company_Full_Address +  '\n' + 'Vendor Name :' + this.selectedVendorInfo.Vendor_Name +  '\n' + 'From : ' + From_Date + ',' + 'To : ' + To_Date
          let d = new Date();
          var fName = 'vendor Ledger_' + d.getTime();
          var params = {
              columnGroups: true,
              skipFooters: false,
              allColumns: true,
              customHeader: row,
              fileName: fName,
          };
          this.gridApiVendorLedger.exportDataAsCsv(params);
      }
  
      ledgeronSelectionChanged() {
          var selectedRows = this.gridApiVendorLedger.getSelectedRows();
          this.ledgerRowSelected = selectedRows[0];
          //console.log("selectedRows", selectedRows);
      }
  
      
    initModalQuery(className) {
        var parent = this;
        // let jqueryclass = className + ' ul.form-group';
        $(className).on('keydown', 'input, select, textarea, input[role=combobox]', function (e) {
          //   console.log("enter");
            var self = $(this)
                , form = self.parents(className + ':eq(0)')
                , focusable
                , next
                ;
            if (e.keyCode == 13) {
                // focusable = form.find('input:not([type="radio"]), input:enabled, a, select, button, textarea, input[role=combobox]').filter(':visible');
                if(this.classList.contains('custom-date')){
                    parent.customDateFormat.GetCustomDateFormat(this, parent.datePipe);
                }
                focusable = form.find('input:not([type="radio"]), input[role=combobox]').filter(':visible');
                next = focusable.eq(focusable.index(this) + 1);
                if (next.length) {
                    next.focus().select();
                } else {
                    $('#okbtn').focus();
                    //form.submit();
                    //parent.addCompany();
                }
                return false;
            }
        });
    }
    removeHotKeyServices(hotkeyarr) {
        this.hotkeysService.remove(hotkeyarr);
        this.hotkeysService.remove(this.hotkeyList);
        this.hotkeysService.add(this.hotkeyList);
    }
      /*  Vendor Ledger   -->   */

      NavigateScreen(event){
        var parent = this;
        var self = this;
      //   console.log("Column Data :::: ", event.column.colId);
      //   console.log("Column Data :::: ", event.column.userProvidedColDef.field);

        if (event.column.colId == "TransNo" || event.column.userProvidedColDef.field == "TransNo") // only first column clicked
        {   
            if((Number(event.data.Transaction_No) ? Number(event.data.Transaction_No) : 0) > 0){
              //   console.log("Naivgation Data :::: ", event.data);
                var data_navi = {"ScreenType" : Number(event.data.Transaction_Type) ,"Transaction_No" : Number(event.data.Transaction_No)}
                parent.commonFunction.Nevigate_Document_Entry(data_navi); 
            }
        } 
        
        if (event.column.colId == "Doc_No" || event.column.userProvidedColDef.field == "Doc_No") // only first column clicked
        {   
            if((Number(event.data.Transaction_No) ? Number(event.data.Transaction_No) : 0) > 0){
              //   console.log("Naivgation Data :::: ", event.data);
                var data_navi = {"ScreenType" : Number(8) ,"Transaction_No" : Number(event.data.Transaction_No)}
                parent.commonFunction.Nevigate_Document_Entry(data_navi); 
            }
        }
      
    }


    /*  <--  Order History   */
     orderhistoryRef: NgbModalRef;
     orderhistoryModal(orderhistory) {
        /*  if (!this.modalService.hasOpenModals()) { */
            
         this.getAllOrderHistory();
         this.orderhistoryRef = this.modalService.open(orderhistory, { size: 'lg', windowClass: 'data-show order-history-modal pending-order-modal' });
         setTimeout(() => {
             $('.order-history-modal input#From_Date').focus().select();
                 this.initModalQuery('.order-history-modal');
             let ctrlo = new Hotkey('alt+o', (event: KeyboardEvent): boolean => {
                 $('.order-history-modal #okbtn').trigger('click');
                 return false; // Prevent bubbling
             }, ['INPUT', 'SELECT', 'TEXTAREA']);
             // this.hotkeyList.push(ctrls);
             this.hotkeyListModal.push(ctrlo);
             this.hotkeysService.add(ctrlo);
             let ctrle = new Hotkey('alt+e', (event: KeyboardEvent): boolean => {
                 $('#orderhistoryExcel').trigger('click');
                 return false; // Prevent bubbling
             }, ['INPUT', 'SELECT', 'TEXTAREA']);
             // this.hotkeyList.push(ctrls);
             this.hotkeyListModal.push(ctrle);
             this.hotkeysService.add(ctrle);
 
             let self = this;
             this.orderhistoryRef.result.then(() => {
               //   console.log("when user closes");
                 self.orderhistoryRef = undefined;
                 self.removeHotKeyServices(self.hotkeyListModal);
             }, () => {
               //   console.log("backdrop click");
                 self.orderhistoryRef = undefined;
                 self.removeHotKeyServices(self.hotkeyListModal);
             });
         }, 200);  
   /*   } */
     }
 

     orderhisonGridReady(params) {
         this.gridApiOrderHis = params.api;
         this.gridColumnApiOrderHis = params.columnApi;
         this.gridApiOrderHis.sizeColumnsToFit();
         var myInput = document.getElementById("orderhistoryag");
 
         myInput.addEventListener("keydown", function (event) {
             // console.log("event", event);
             if (event.keyCode == 8) {
                 setTimeout(() => {
                     $('.order-history-modal #From_Date').focus().select();
                 }, 200);
             }
         });
     }
 
     getAllOrderHistory() {
         if (this.orderSearch.To_Date < this.orderSearch.From_Date) {
             this.toastWarningMsg("To Date cannot be less than From Date");
         }
         else {
             if (this.orderSearch.To_Date != null || this.orderSearch.From_Date != null) {
 
                 var data = {
                     "Vendor_ID": this.selectedVendorInfo.Vendor_ID, 
                     "Unit_ID": this.unitInfo.Unit_ID, 
                     "Company_ID": this.unitInfo.Company_ID,
                     "From_Date": moment(this.orderSearch.From_Date).format('YYYY-MM-DD'),
                     "To_Date": moment(this.orderSearch.To_Date).format('YYYY-MM-DD')
                 };
               //   console.log("data", data);
                 this.busy = this.http.post('/api/vendors/Get_Order_History_Vendor_Wise', data)
                     .subscribe(response => {
                         this.orderhistorycolumnDefs = [
                             // { headerName: 'Code', field: 'Party_Code', width: 100 },
                             // { headerName: 'Party Name', field: 'Party_Name', width: 200 },
                             { headerName: 'Product Name', field: 'Product_Desc', width: 150 },
                             { headerName: 'Order No', field: 'Doc_No', width: 150 },
                             { headerName: 'Order Date', field: 'Doc_Date', width: 200, cellRenderer: (data) => {
                                     // return moment(data.value).format(this.dateFormat.dateInputFormat);
                                     if (data.value) {
                                         return moment(data.value).format(this.dateFormat.dateInputFormat);
                                     }
                                     else {
                                         return '-';
                                     }
                                 }
                             },
                             { headerName: 'Qty', field: 'Entry_Qty', width: 100, cellStyle:{ textAlign:'right'} },
                             { headerName: 'Qty Recd.', field: 'RCVD_QTY', width: 100, cellStyle:{ textAlign:'right'} },
                             //{ headerName: 'Fqty Recd.', field: 'ex', width: 100, cellStyle:{ textAlign:'right'} },
                             { headerName: 'Pur Ref', field: 'Pur_Ref', width: 100 },
                             { headerName: 'Pur Ref Date', field: 'Pur_Ref_Date', width: 200 },
                             { headerName: 'Status', field: 'O_Status', width: 100 },
                         ];
                         this.orderhistoryrowData = response;
                         if (this.orderhistoryrowData.length > 0) {
                             setTimeout(() => {
                                 let allColumnIds = [];
                                 this.gridApiOrderHis.getModel().getRow(0).setSelected(true);
                                 this.gridApiOrderHis.setFocusedCell(0, "Product_Desc");
                                 this.gridColumnApiOrderHis.getAllColumns().forEach(function (column) {
                                     allColumnIds.push(column.colId);
                                 });
                                 this.gridColumnApiOrderHis.autoSizeColumns(allColumnIds);
                                 this.gridApiOrderHis.sizeColumnsToFit();
                             }, 100);
                         }
                     })
             } else {
                 this.toastWarningMsg("Please Enter Date");
                 $("#From_Date").focus();
             }
         }
     }
 
     exportExcelOrderHistory() {
         let To_Date = moment(this.ledgerSearch.To_Date).format('DD-MMM-YYYY');
         let From_Date = moment(this.ledgerSearch.From_Date).format('DD-MMM-YYYY');
         let row =  this.unitInfo.Company_Name +  '\n' + this.unitInfo.Company_Full_Address +  '\n' + 'Vendor Name : ' + this.selectedVendorInfo.Vendor_Name +  '\n'+ 'From : ' + From_Date + ',' + 'To : ' + To_Date
         let d = new Date();
         var fName = 'Order_History_' + d.getTime();
         var params = {
             columnGroups: true,
             skipFooters: false,
             allColumns: true,
             customHeader: row,
             fileName: fName,
         };
         this.gridApiOrderHis.exportDataAsCsv(params);
     }
 
     orderhisonSelectionChanged() {
         var selectedRows = this.gridApiOrderHis.getSelectedRows();
       //   console.log("selectedRows", selectedRows);
     }
 
     /*  Order History   -->   */

     /* Expiry Ledger Start */

    

    expiryLedgerModal(expiryLedger) {
      /*   if (!this.modalService.hasOpenModals()) { */
           
       this.getAllexpiryLedger();
        this.expiryLedgerRef = this.modalService.open(expiryLedger, { size: 'lg', windowClass: 'data-show order-history-modal pending-order-modal' });
            setTimeout(() => {
                $('.order-history-modal input#From_Date').focus().select();
                    this.initModalQuery('.order-history-modal');
                let ctrlo = new Hotkey('alt+o', (event: KeyboardEvent): boolean => {
                    $('.order-history-modal #okbtn').trigger('click');
                    return false; // Prevent bubbling
                }, ['INPUT', 'SELECT', 'TEXTAREA']);
                // this.hotkeyList.push(ctrls);
                this.hotkeyListModal.push(ctrlo);
                this.hotkeysService.add(ctrlo);
                let ctrle = new Hotkey('alt+e', (event: KeyboardEvent): boolean => {
                    $('#orderhistoryExcel').trigger('click');
                    return false; // Prevent bubbling
                }, ['INPUT', 'SELECT', 'TEXTAREA']);
                // this.hotkeyList.push(ctrls);
                this.hotkeyListModal.push(ctrle);
                this.hotkeysService.add(ctrle);

                let self = this;
                this.orderhistoryRef.result.then(() => {
                  //   console.log("when user closes");
                    self.expiryLedgerRef = undefined;
                    self.removeHotKeyServices(self.hotkeyListModal);
                }, () => {
                  //   console.log("backdrop click");
                    self.expiryLedgerRef = undefined;
                    self.removeHotKeyServices(self.hotkeyListModal);
                });
            }, 200);  
        /* } */
    }
 
    expiryLedgeronGridReady(params) {
        this.gridApiexpiryLedger = params.api;
        this.gridColumnApiexpiryLedger = params.columnApi;
        this.gridApiexpiryLedger.sizeColumnsToFit();
        var myInput = document.getElementById("expiryLedgerag");

        myInput.addEventListener("keydown", function (event) {
            // console.log("event", event);
            if (event.keyCode == 8) {
                setTimeout(() => {
                    $('.order-history-modal #From_Date').focus().select();
                }, 200);
            }
        });
    }

    getAllexpiryLedger() {
        if (this.orderSearch1.To_Date < this.orderSearch1.From_Date) {
            this.toastWarningMsg("To Date cannot be less than From Date");
        }
        else {
            if (this.orderSearch1.To_Date != null || this.orderSearch1.From_Date != null) {

                var data = {
                    "Vendor_ID": this.selectedVendorInfo.Vendor_ID, 
                    "Unit_ID": this.unitInfo.Unit_ID, 
                    "Company_ID": this.unitInfo.Company_ID,
                    "From_Date": moment(this.orderSearch1.From_Date).format('YYYY-MM-DD'),
                    "To_Date": moment(this.orderSearch1.To_Date).format('YYYY-MM-DD'),
                    "Type" : 'V'
                };
              //   console.log("data", data);
                this.busy = this.http.post('/api/vendors/Get_Expiry_Ledger_V_C', data)
                    .subscribe(response => {
                        this.expiryLedgercolumnDefs = [
                            // { headerName: 'Code', field: 'Party_Code', width: 100 },
                            // { headerName: 'Party Name', field: 'Party_Name', width: 200 },
                            { headerName: 'Sr. No', field: 'SR_NO', width: 50 },
                            { headerName: 'Date', field: 'Invoice_Date', width: 200 },
                            { headerName: 'Trans. No', field: 'Invoice_No', width: 150 },
                            { headerName: 'Trans. Type', field: 'DocType_Code', width: 150 },
                            { headerName: 'Debit', field: 'Debit', width: 100 },
                            { headerName: 'Credit', field: 'Credit', width: 100 },
                        ];
                        var res = [];
                        res.push(response);
                       // console.log("RESULT", response);

                        this.expiryLedgerrowData = res[0].HeaderTrans;
                       // console.log("RESULT", this.expiryLedgerrowData);

                        this.expiryLedgerrowDataFooter = res[0].FooterTrans;
                      ////   console.log("RESULT", this.expiryLedgerrowDataFooter);

                        this.expiryLedgeBalance = this.expiryLedgerrowDataFooter[0].Balance;
                        this.expiryLedgeledgerDebit = this.expiryLedgerrowDataFooter[0].Debit;
                        this.expiryLedgeledgerCredit = this.expiryLedgerrowDataFooter[0].Credit;





                        if (this.expiryLedgerrowData.length > 0) {
                            setTimeout(() => {
                                let allColumnIds = [];
                                this.gridApiexpiryLedger.getModel().getRow(0).setSelected(true);
                                this.gridApiexpiryLedger.setFocusedCell(0, "Product_Desc");
                                this.gridColumnApiexpiryLedger.getAllColumns().forEach(function (column) {
                                    allColumnIds.push(column.colId);
                                });
                                this.gridColumnApiexpiryLedger.autoSizeColumns(allColumnIds);
                                this.gridApiexpiryLedger.sizeColumnsToFit();
                            }, 100);
                        }
                    })
            } else {
                this.toastWarningMsg("Please Enter Date");
                $("#From_Date").focus();
            }
        }
    }

    exportExcelexpiryLedger() {
          let To_Date = moment(this.ledgerSearch.To_Date).format('DD-MMM-YYYY');
        let From_Date = moment(this.ledgerSearch.From_Date).format('DD-MMM-YYYY');
        let row =  this.unitInfo.Company_Name +  '\n' +this.unitInfo.Company_Full_Address +  '\n' + 'Vendor Name : ' + this.selectedVendorInfo.Vendor_Name  +  '\n'+ 'From : ' + From_Date + ',' + 'To : ' + To_Date
        let d = new Date();
        var fName = 'Expiry_Ledger_' + d.getTime();
        var params = {
            columnGroups: true,
            skipFooters: false,
            allColumns: true,
            customHeader: row,
            fileName: fName,
        };
        this.gridApiexpiryLedger.exportDataAsCsv(params);
    }

    expiryLedgerSelectionChanged() {
        var selectedRows = this.gridApiexpiryLedger.getSelectedRows();
      //   console.log("selectedRows", selectedRows);
    }

    onPopupFilterTextBoxChanged(e){
        let value = $('input#filter-text-box1').val();
        this.gridApiVendorLedger.setQuickFilter(value);
    }

    venHandleKeyDown(event) {
        // console.log("event", event);
        if (event.which == 13) {
            this.gridApiVendorLedger.setFocusedCell(0, "DocType_Desc");
        }
    }

    onPopupFilterTextBoxChanged1(e){
        let value = $('input#filter-text-box1').val();
        this.venOutstandingGrid.setQuickFilter(value);
    }

    venKeyDown(event) {
        // console.log("event", event);
        if (event.which == 13) {
            this.venOutstandingGrid.setFocusedCell(0, "Doc_No");
        }
    }
    /* Expiry Ledger End */

}